module.exports = __webpack_public_path__ + "img/4.e453bfe9.jpg";